import React, { useState } from "react";
import WatchListDetail from "../components/WatchList/WatchListDetail";
import WatchListList from "../components/WatchList/WatchListList";

const WatchList = () => {
  const [detailView, setDetailView] = useState(false);
  if (detailView) {
    return <WatchListDetail />;
  }
  return <WatchListList />;
};

export default WatchList;
